import { createTypedSxStyles } from '@opengov/capital-mui-theme';
export const styles = createTypedSxStyles({
  progressTrackerPreviewContainer: {
    width: '100%',
    minHeight: '200px'
  },
  progressTrackerPreviewEmptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  }
});